import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

export const useAppNavigation = () => {
  const navigate = useNavigate();

  const scrollToTop = useCallback(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' as ScrollBehavior });
  }, []);

  const goTo = useCallback(
    (path: string) => {
      navigate(path);
      requestAnimationFrame(scrollToTop);
    },
    [navigate, scrollToTop]
  );

  const scrollToId = useCallback((id: string) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
  }, []);

  return { navigate, goTo, scrollToId, scrollToTop };
};
